import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Crown } from "lucide-react";
import { getMembershipPlans } from "../lib/hub";

const money = (v) => `$${Number(v || 0).toFixed(2)}`;

const PUBLIC_PLAN_IDS = new Set([
  "build_your_store",
  "pro_ecommerce",
]);

export const HomeBusiness = () => {
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    let active = true;
    getMembershipPlans()
      .then((data) => {
        if (active) {
          setPlans(
            (data.plans || []).filter((plan) =>
              PUBLIC_PLAN_IDS.has(plan.id)
            )
          );
        }
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const skeletons = Array.from({ length: 2 }).map((_, index) => ({
    id: `sk${index}`,
    skeleton: true,
  }));
  const go = (p) => navigate("/membership");

  return (
    <>
      <section className="bg-taven-black text-white py-14" data-testid="home-membership">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.3em] text-taven-gold">TAVEN Memberships</p>
              <h2 className="text-2xl md:text-3xl font-black font-display tracking-tight mt-1">Grow Your Business on TAVEN</h2>
            </div>
            <div className="flex gap-3">
              <Link to="/membership" data-testid="home-membership-all" className="px-4 py-2 bg-taven-gold text-black text-xs font-bold uppercase tracking-wider hover:bg-taven-orange hover:text-white transition-colors">View All Plans</Link>
              <Link to="/my-membership" data-testid="home-my-membership" className="px-4 py-2 border border-white/30 text-xs font-bold uppercase tracking-wider hover:bg-white hover:text-black transition-colors">My Membership</Link>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            {(plans.length ? plans : skeletons).map((p) => (
              p.skeleton ? <div key={p.id} className="h-40 bg-white/5 animate-pulse rounded" /> : (
                <button key={p.id} onClick={() => go(p)} data-testid={`home-plan-${p.id}`}
                  className={`text-left flex flex-col justify-between p-4 rounded-lg border transition-colors ${p.is_pro_ecommerce ? "border-taven-gold bg-taven-gold/10" : "border-white/15 hover:border-taven-gold"}`}>
                  <div>
                    {p.is_pro_ecommerce &&
                      <span className="inline-flex items-center gap-1 text-[10px] font-black uppercase text-taven-gold mb-1"><Crown className="w-3 h-3" />Complete</span>}
                    <p className="text-sm font-black font-display leading-tight">{p.name}</p>
                  </div>
                  <div className="mt-3">
                    <span className="text-xl font-black">{money(p.price)}</span><span className="text-[11px] text-white/50">/{p.billing_interval === "monthly" ? "mo" : p.billing_interval}</span>
                  </div>
                </button>
              )
            ))}
          </div>
          <p className="mt-4 text-[11px] text-white/40">
            Free plans activate instantly with no charge. Paid membership
            billing remains gated until approved.
          </p>
        </div>
      </section>
    </>
  );
};

export default HomeBusiness;
